import React, { FC, useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { formatNumberWithComma } from 'components/DataDisplay';
import { VulnerabilitiesPrioritizationComponent } from 'containers/Dashboard/utils/VulnerabilitiesPrioritizationComponent';
import { selectVulnerabilityOverview } from 'containers/Dashboard/VulnerabilityOverview/selectors';

export const VulnerabilitiesPrioritization: FC = () => {
  const { vulnerabilityPrioritization } = useSelector(
    selectVulnerabilityOverview,
  );
  const { data, isLoading } = vulnerabilityPrioritization;
  const [hostsToPatch, setHostsToPatch] = useState(0);

  useEffect(() => {
    setHostsToPatch(
      data?.internet_exposed_resources_having_patchable_packages_with_explitable_cve ??
        0,
    );
  }, [data]);

  return (
    <VulnerabilitiesPrioritizationComponent
      vulnerabilityPrioritization={data}
      isLoading={isLoading}
      labelSpacing={0}
      subHeader={
        formatNumberWithComma(hostsToPatch) +
        ' host' +
        (hostsToPatch === 1 ? '' : 's') +
        ' to patch'
      }
    />
  );
};
